import React from 'react';
import { Dialog, DialogTitle, Typography } from '@mui/material';
import { buildQaId } from 'utils/build-qa-id';
import { makeStyles } from '@mui/styles';
import { notifyError } from 'actions/action-notifications';
import { useDispatch } from 'react-redux';
import { MODAL_QA_ID, ADD_PHARMACY } from '../constants';
import { cpStyle } from '../index.styles';
import { CustomerProfileModalInnerForm } from './inner-form';
import { IResult } from '../table/types';

interface ICustomerProfileModalProps {
  open: boolean;
  onCancel: () => void;
  onSuccess: () => void;
  allCustomers: { label: string; value: number }[];
  selectedParentRow: IResult | null;
  customerId: number;
}
const qaIdBuilder = buildQaId(MODAL_QA_ID);

export const NewCustomerProfileModal: React.FC<ICustomerProfileModalProps> = (
  props: ICustomerProfileModalProps,
): JSX.Element => {
  const useStyles = makeStyles(cpStyle);
  const classes = useStyles();
  const dispatch = useDispatch();

  const { open, onSuccess, onCancel, allCustomers, selectedParentRow, customerId } = props;

  const onError = (msg: string): void => {
    dispatch(notifyError(msg));
  };

  return (
    <Dialog open={open} fullWidth onClose={onCancel} data-qa-id={qaIdBuilder('root')} maxWidth="lg">
      <DialogTitle className={classes.titleWrp}>
        <Typography variant="h5" className={classes.title}>
          {selectedParentRow ? `Edit ${selectedParentRow.name}` : ''}
        </Typography>
      </DialogTitle>
      <CustomerProfileModalInnerForm
        onSuccess={onSuccess}
        onCancel={onCancel}
        onError={onError}
        allCustomers={allCustomers}
        selectedParentRow={selectedParentRow}
        customerId={customerId}
      />
    </Dialog>
  );
};
